import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';

export default function SalesTableHeader(props) {
  const { title, startYmd, endYmd, salesAmount, bgColor, component, onClick } = props;

  const handleClick = (e) => {
    onClick({ startYmd, endYmd });
  };

  return (
    <Box sx={{ display: 'block' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 2 }}>
        <Typography variant="h6">
          {title}
          <span style={{ fontSize: '16px', marginLeft: '4px' }}>매출</span>
          <span style={{ fontSize: '12px', marginLeft: '4px' }}>{`( ${startYmd || 'yyyy-MM-dd'} ~ ${endYmd || 'yyyy-MM-dd'} )`}</span>
        </Typography>
        {component}
      </Box>
      <Box
        sx={{
          bgcolor: bgColor || '#2196f3',
          pt: 1,
          alignItems: 'center',
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`
        }}
      >
        <Typography variant="h6" gutterBottom align="center">
          <span style={{ fontSize: '16px' }}>매출액</span>{' '}
          <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={handleClick}>
            {salesAmount?.toLocaleString('en-US') || 0}
          </span>
          <span style={{ fontSize: '16px' }}> 원</span>
        </Typography>
      </Box>
    </Box>
  );
}
